module.exports = __webpack_public_path__ + "f40667b5c4bde102b8a5e41148d42ff2.pdf";